import { loadOptions } from '../actions/loadOptions';
import { setOptionsLoadState } from '../actions/setOptionsLoadState';
import fetchDefaultConfigFromService from '../service/fetchDefaultConfigFromService';
import fetchUserOptionsFromService from '../service/fetchUserOptionsFromService';
import LoadState from '../store/schema/LoadState';
import getStore from '../store/store';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';

let fetchingOptionsPromise: Promise<void> | null = null;

orchestrator(loadOptions, actionMessage => {
    doLoadOptions()?.then(() => {
        if (actionMessage.onOptionsLoaded) {
            actionMessage.onOptionsLoaded();
        }
    });
});

function doLoadOptions(): Promise<void> {
    const store = getStore();
    switch (store.optionsLoadState) {
        case LoadState.Loading:
            trace.info('[owa-proofing-options] Options already loading. Returning promise');
            return fetchingOptionsPromise || Promise.reject();
        case LoadState.Loaded:
            trace.info('[owa-proofing-options] Options already loaded. Resolving promise');
            return Promise.resolve();
        case LoadState.NotLoaded:
        default:
            trace.info('[owa-proofing-options] Options not loaded yet. Returning new promise');
            setOptionsLoadState(LoadState.Loading);
            return (fetchingOptionsPromise = new Promise(resolve => {
                fetchAndProcessOptions().then(() => {
                    fetchingOptionsPromise = null;
                    resolve();
                });
            }));
    }
}

async function fetchAndProcessOptions(): Promise<void> {
    try {
        const store = getStore();
        // First fetch the user options from the OWS' user settings
        await fetchUserOptionsFromService();
        const languageId = store.userOptions.proofingLocale;

        // Now fetch the default config from the Editor service
        if (languageId) {
            await fetchDefaultConfigFromService(languageId);
            trace.info('[owa-proofing-options] Options finished loading');
            setOptionsLoadState(LoadState.Loaded);
            return;
        }
    } catch (e) {
        trace.warn('[owa-proofing-options] Options failed to load');
    }

    setOptionsLoadState(LoadState.NotLoaded);
}
